import { useState, useEffect } from 'react';
import { Tabs, Space, Table } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, Tooltip, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import Amortissement from '../../../../Functions/Traitement/Amortissement';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../Models/Pret';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import Datas from "../../../../Data/Data.json"
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import DataDecaissement from '../../../../Types/DataDecaissement';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import DataAnticipationPret from '../../../../Types/DataAnticipationPret';
import internal from 'stream';
import { Error, GppGood } from '@mui/icons-material';
import DataDeclassement from '../../../../Types/DataDeclassement';

const DeclassementPret = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [radioaCheck, setRadioaCheck] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [data, setData] = useState<any[]>([])

  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body ": {
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));

  const onSelectChange = (newSelectedRowKeys: any) => {
    if (newSelectedRowKeys.length != 0) {
      setEnregActve(false)
    } else {
      setEnregActve(true)
    }

    console.log('selectedRowKeys changed: ', data[newSelectedRowKeys]);
    form.setFieldsValue(data[newSelectedRowKeys])
    setSelectedRowKeys(newSelectedRowKeys);

  }; const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    localStorage.setItem(Data.LocalVariable.reset, '0')
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields()
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    setData([])
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }

  const columns: ColumnsType<any> = [
    {
      title: 'N°',
      dataIndex: 'NUMSEQ',
    },
    {
      title: 'Date Ech',
      dataIndex: 'DATECH',
    },
    {
      title: 'Cpt Ordinaire',
      dataIndex: 'CPTICA',
    },
    // {
    //   title: 'Cpt Prêt',
    //   dataIndex: 'CPTAVC',
    // },
    {
      title: 'Cpt Eng',
      dataIndex: 'CPTAVC',
    },
    {
      title: 'Cpt Impayé',
      dataIndex: 'CPTIMP',
    },
    // {
    //   title: 'Capital',
    //   dataIndex: 'MTNCRE',
    // },
    {
      title: 'Amort',
      dataIndex: 'AMMORT',
    },
    // {
    //   title: 'Taxe',
    //   dataIndex: 'monTaxe',
    // },
    {
      title: 'Intérêt',
      dataIndex: 'INTERE',
    },
    {
      title: 'Epargne',
      dataIndex: 'MONTEPARG',
    },
    {
      title: 'Annuité',
      dataIndex: 'ANNUIT',
    },
    {
      title: 'Statut',
      dataIndex: 'IMPAYE',
    },
  ];


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Détail déclassement
        </span>
      ),
      children: <Tab1 form={form} />,
    }
  ];

  const onFinish = (values: any) => {
    let option = form.getFieldValue('option')
    if (option != null) {
      let numDos = form.getFieldValue('NUMDOS')
      let codAge = user.codage
      let utiSai = user.coduti

      var declassements: DataDeclassement[] = []

      selectedRowKeys.map((seq) => {
        declassements.push(
          {
            "numDos": numDos,
            "codAge": codAge,
            'utiSai': utiSai,
            "numSeq": parseInt(seq + ""),
            'option': option
          }
        )
      })

      //alert(JSON.stringify(anticipations))

      SweetAlert.fire({
        title: "Voulez-vous déclasser les échéance " + JSON.stringify(selectedRowKeys) + " impayé du prêt N°" + numDos + " ?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)
          let dta = Crypter.encrypt(JSON.stringify(declassements));

          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.DeclassementPret,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: dta,
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  let code = numDos
                  //form.resetFields()
                  //localStorage.clear()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Result, text: res.Message, icon: "success" })
                  //initialiazeButton()
                  //localStorage.setItem(Data.LocalVariable.reset, "1")
                  //initialiazeButton()
                  consult()
                  setSbmit("")

                  //setData(data.filter((d) => d.NUMDOS != num))
                  // LoadDataTable()
                  setSelectedRowKeys([])
                }
                else {
                  SweetAlert.fire({ title: res.Result, text: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            })
        }
      })
    } else {
      SweetAlert.fire({ title: "Veillez selectionner l'option de déclassement'", icon: "warning" })
    }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {
    localStorage.setItem(Data.LocalVariable.reset, "1")
    setData([])
    //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
    let data = Crypter.encrypt(form.getFieldValue("NUMDOS") + "|" + Data.LocalVariable.LoanStep.Declassement);
    let numdos = form.getFieldValue("NUMDOS")

    if (data.length != 0) {
      form.setFieldValue('garantie', '')
      form.setFieldValue('avaliste', '')
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      form.setFieldValue('NUMDOS', numdos)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetPret,
        headers: {
          'CipherNumDos': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res)
            if (res.StatutCode == 200) {
              form.setFieldsValue(res.Result.Table[0])

              LoadAmmort(res.Result.Table1)
              localStorage.clear()
              initialiazeButton()
              cunsultButton()
              setSelectedRowKeys([])
              if(res.Result.Table1.length == 0){
                SweetAlert.fire({
                  title: 'Aucune échéance du pret '+numdos+' est en impayé',
                  icon: 'warning'
                })
              }
            }
            else {
              localStorage.removeItem(Data.LocalVariable.reset)
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset)
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        });
    }
  }

  function LoadAmmort(data: any) {
    let newData: any[] = []
    data.map((d: any, indice: number) => {
      newData.push(
        {
          key: parseInt(d.NUMSEQ),
          NUMSEQ: d.NUMSEQ,
          DATECH: ReformatDate(d.DATECH),
          CPTICA: d.CPTICA,
          CPTINT: d.CPTINT,
          CPTIMP: d.CPTIMP,
          AMMORT: formatNumber(d.AMMORT),
          INTERE: formatNumber(d.INTERE),
          MONTEPARG: formatNumber(d.MONTEPARG),
          ANNUIT: formatNumber(d.ANNUIT),
          IMPAYE: <><Tooltip title={d.IMPAYE == '0'? "Echance non atteint" : "Echance en impayé"}>{d.IMPAYE == '0'? <GppGood fontSize='small' color='success' /> : <Error fontSize='small' color='error' />}</Tooltip><label style={{color: 'rgba(255, 255, 255, 0)'}} htmlFor="">...</label></>,
          CPTAVC: d.CPTAVC
          
        }
      )
      setData(newData)
    })
  }

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>DECLASSEMENT DE PRET</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>

          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>
                <Button size='large' className='bt_add' onSubmit={onFinish} disabled={enregActve} type="ghost" htmlType="submit" block>
                  Declasser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div>
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
              <Box display={"flex"} marginTop={-28} fontStyle="inherit" className='border-left tabElementAuto'>
                <Spin spinning={loading}>
                  <Form disabled={radioaCheck}>
                    <ThemeTable size='small' style={{ width: 'auto' }} rowSelection={{ ...rowSelection, type: "checkbox", }} columns={columns} dataSource={data} scroll={{ y: 350, x: "auto" }} pagination={false} />
                  </Form>
                </Spin>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default DeclassementPret;